import { toast } from "@/components/ui/toast";

export function error(
  description: React.ReactNode,
  title?: string,
  suppressConsole = false,
) {
  !suppressConsole && console.error(description);

  toast.error(title, { description });
}

export function info(description: React.ReactNode, title?: string) {
  toast.success(title, { description });
}
